import { useEffect, useState } from "react";
import { FormattedMessage as FM } from "react-intl";

import FormField from "components/MeForm/FormField";
import upStore from "store/upStore";
import { classNames } from "tools/ui";
import { isHexColor, toFullHex } from "../helpers/colors";
import { DEFAULT_PICKER_COLOR } from "../constants";

function ColorPickerField(props) {
  const { field, attrs, data, value, onValueChange, inherited = "" } = props;
  const { name, readOnly } = field;
  const { level } = attrs;
  const current = value || "";
  const [text, setText] = useState(current);
  const valid = !text || isHexColor(text);
  const shown = current || inherited;
  const color = isHexColor(shown) ? shown : null;

  useEffect(() => {
    setText(current);
  }, [current]);

  function commit(nextValue) {
    if (readOnly) return;
    data.value = nextValue;
    onValueChange(name, nextValue);
    upStore(level, {
      fieldName: name,
      value: nextValue,
      valueActive: nextValue,
      field: field,
    });
  }

  function onTextChange(event) {
    const typed = event.target.value.trim();
    setText(typed);
    if (!typed || isHexColor(typed)) commit(typed || null);
  }

  function onTextBlur() {
    if (!valid) setText(current);
  }

  function clearColor() {
    commit(null);
  }

  function onPickerChange(event) {
    setText(event.target.value);
    commit(event.target.value);
  }

  return (
    <FormField {...field}>
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <label
            className="relative block size-12 shrink-0 cursor-pointer overflow-hidden rounded-md border border-slate-300"
            style={{ backgroundColor: color || DEFAULT_PICKER_COLOR }}
          >
            <input
              type="color"
              disabled={readOnly}
              value={toFullHex(shown)}
              onChange={onPickerChange}
              className="absolute inset-0 size-full cursor-pointer opacity-0"
            />
          </label>
          <input
            id={name}
            name={name}
            type="text"
            value={text}
            disabled={readOnly}
            placeholder={inherited || "#1f3a5f"}
            maxLength={7}
            onChange={onTextChange}
            onBlur={onTextBlur}
            className={classNames(
              "h-12 w-full rounded-md border bg-white px-3 font-mono text-sm uppercase text-neutral-700 focus:outline-none",
              valid
                ? "border-slate-300 focus:border-cyan-500"
                : "border-red-400 focus:border-red-500",
            )}
          />
        </div>
        {!valid && (
          <p className="text-xs text-red-600">
            <FM id="melhous.dash.color.invalid" />
          </p>
        )}
        {!current && inherited && (
          <span className="inline-block rounded bg-sky-50 px-2 py-0.5 text-xs font-medium text-sky-900">
            <FM id="melhous.dash.color.from_hotel" />
          </span>
        )}
        {current && !readOnly && (
          <button
            type="button"
            onClick={clearColor}
            className="block text-xs font-medium text-sky-900 underline"
          >
            <FM id="melhous.dash.color.clear" />
          </button>
        )}
      </div>
    </FormField>
  );
}

export default ColorPickerField;
